import { DEFAULT_RESUME_DATA, ResumeData } from '../resume-preview/resumeTypes';

/** Собирает ResumeData из ответа GET /api/admin/resumes/:id (как в NewResumeEditor). */
export function apiResumeToResumeData(raw: Record<string, any>): ResumeData {
  const d = DEFAULT_RESUME_DATA;
  const phones = raw.contacts?.phones;
  const merged: ResumeData = {
    ...d,
    ...raw,
    lang: (raw.lang || 'ru') as ResumeData['lang'],
    name: { ...d.name, ...(typeof raw.name === 'object' && raw.name ? raw.name : {}) },
    contacts: {
      email: raw.contacts?.email ?? d.contacts.email,
      phones: Array.isArray(phones) ? phones : d.contacts.phones,
    },
    location: {
      ...d.location,
      ...(typeof raw.location === 'object' && raw.location ? raw.location : {}),
    },
    meta: {
      ...d.meta,
      ...(typeof raw.meta === 'object' && raw.meta ? raw.meta : {}),
    },
    experience: Array.isArray(raw.experience) ? raw.experience : d.experience,
    education: Array.isArray(raw.education) ? raw.education : d.education,
    courses: Array.isArray(raw.courses) ? raw.courses : d.courses,
    hobbies: Array.isArray(raw.hobbies) ? raw.hobbies : d.hobbies,
    languages: Array.isArray(raw.languages) ? raw.languages : d.languages,
    skills: Array.isArray(raw.skills) ? raw.skills : d.skills,
    extra: {
      ...d.extra,
      ...(typeof raw.extra === 'object' && raw.extra ? raw.extra : {}),
    },
    // Не подменять на DEFAULT: иначе normalizeResumeForPdf/getTemplateAndOverridesForPdf всегда видят template-01.
    sharing: {
      ...d.sharing,
      ...(typeof raw.sharing === 'object' && raw.sharing ? raw.sharing : {}),
    },
  };
  if ((!merged.position || String(merged.position).trim() === '') && typeof raw.title === 'string') {
    merged.position = raw.title;
  }
  return merged;
}
